export default __webpack_public_path__ + "static/12_33-7479891f42e812b3cb1dcef8895c6137.png";